<template>
<div>
  <h4>{{ $t('projectsUsage') }}</h4>
  <p class="lighter">This will show only projects you have access to - if you are not a organization wide admin or editor it might seem to you that the item is not in use while it actually is.</p><br />
  <div @click="loadUsage" v-if="loaded" class="settings-button switched-colors d-inline-block mt-2 mb-2">
    {{ $t('reload') }}
  </div>
  <div @click="loadUsage" v-if="!loaded" class="settings-button switched-colors d-inline-block mt-2 mb-2">
    {{ $t('load') }}
  </div>
  <loading-spinner v-if="loading" />
  <div v-else>
    <div :key="instance.id" v-for="instance in instances">
      <router-link :to="'/project/' + instance.project.id + '/general'">{{ instance.project.name }}</router-link>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: "AssetUsage",
  props: {
    assetId: {type: String, required: true},
  },
  data() {
    return {
      instances: [],
      loaded: false,
      loading: false,
    }
  },
  methods: {
    loadUsage() {
      this.loading = true;
      this.$store.dispatch('clientGetCrossProjectInstances', {
        filter: 'assetId eq ' + this.assetId,
        include: 'project'
      }).then(instances => {
        this.instances = instances;
        this.loaded = true;
        this.loading = false;
      })
    },
  }
}
</script>